<template lang="pug">
  .fill-io-in(v-loading="loading")
    title-bar {{ $t('填写IO号') }}

    template(v-if="isView")
      el-row(:gutter="20")
        el-col.text-right(:span="4") {{ $t('IO号') }}
        el-col(:span="8") {{ log && log.campaign_io.map(i => i.io).join(', ') }}
    template(v-else)
      el-row(:gutter="20")
        el-col.text-right.required(:span="4") {{ $t('IO号') }}
        el-col(:span="4")
          el-input(v-model="data[0].io")
      el-row(
        v-for="item, index in data"
        v-if="index !== 0"
        :key="index"
        :gutter="20"
      )
        el-col(:span="4" :offset="4")
          el-input(v-model="item.io")
        el-col(:span="4")
          el-button(
            icon="el-icon-delete"
            circle
            style="margin-left: 5px"
            @click="delIo(index)"
          )

    el-row(v-if="!isView" :gutter="20")
      el-col(:span="4" :offset="4")
        el-button(@click="addIo" type="text") {{ $t('添加IO号') }}

    el-row
      el-col(
        :offset="4"
        :span="20"
      )
        footer-button(
          v-if="!isView"
          @confirm="onConfirm"
          @cancel="$router.push('/campaign/process')"
        )
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import { format4backend } from '@/umcc/util'

export default {
  components: {
    TitleBar,
    FooterButton
  },
  data () {
    return {
      loading: false,
      data: [
        {
          io: ''
        }
      ],
      log: null
    }
  },
  mounted () {
    if (this.isView) this.fetchLog()
  },
  computed: {
    isBypass () {
      return this.$store.state.campaign.campaignSurvey.is_bypass === 1
    }
  },
  methods: {
    fetchLog () {
      this.loading = true
      axios
        .get('/common/getBusinessLog', {
          params: {
            servlet_path: this.$route.path,
            business_key: this.$store.state.campaign.id
          }
        })
        .then(res => {
          this.log = res
          this.loading = false
        })
    },
    onConfirm () {
      const params = {
        campaign_id: this.$store.state.campaign.id,
        campaign_io: this.data.filter(i => i.io !== ''),
        servlet_path: this.$route.path,
        task_id: this.$store.state.campaign.taskId
      }
      if (params.campaign_io.length === 0) {
        this.loading = false
        this.$message.error(this.$t('请填写必填项'))
        return
      }

      const regexp = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/
      if (params.campaign_io.some(i => i.io.length > 100)) {
        this.$message.error(this.$t('IO号长度不能超过100字'))
        return
      }
      if (params.campaign_io.some(i => !regexp.test(i.io))) {
        this.$message.error(this.$t('请输入正确的IO号'))
        return
      }
      this.loading = true
      let apiUrl = '/management/campaign/lastUpdateCampaignIO'
      if (this.isBypass) {
        apiUrl = '/management/bypassCampaign/updateCampaignIO'
      }
      axios.post(apiUrl, format4backend(params))
        .then(res => {
          this.loading = false
          if (this.isBypass) {
            this.$store.commit('campaign/setPhaseType', 3)
          }
          this.$router.push('/campaign/process')
        })
    },
    addIo () {
      this.data.push({
        io: ''
      })
    },
    delIo (index) {
      this.data.splice(index, 1)
    }
  }
}
</script>
